import * as XLSX from 'xlsx';

import { BulkColumnConfig } from './types';

export const buildColumnKeyMap = (columns: BulkColumnConfig[]): Record<string, string> => {
    const map: Record<string, string> = {};
    columns.forEach((col) => {
        map[col.label.toLowerCase()] = col.key;
        map[col.key.toLowerCase()] = col.key;
    });
    return map;
};

export const mapRow = (
    row: Record<string, any>,
    columnKeyMap: Record<string, string>,
): Record<string, any> => {
    const mapped: Record<string, any> = {};
    Object.keys(row).forEach((key) => {
        const normalizedKey = key.toLowerCase().trim();
        const fieldKey = columnKeyMap[normalizedKey];
        if (fieldKey) {
            mapped[fieldKey] = row[key];
        }
    });
    return mapped;
};

export const downloadTemplate = (columns: BulkColumnConfig[], fileName: string) => {
    const headers = columns.map((col) => col.label);
    const exampleRow = columns.map((col) => col.example);

    const worksheet = XLSX.utils.aoa_to_sheet([headers, exampleRow]);

    worksheet['!cols'] = columns.map((col) => ({
        wch: Math.max(col.label.length, col.example.length, 20),
    }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

    XLSX.writeFile(workbook, `${fileName}.xlsx`, { bookType: 'xlsx' });
};

export const parseFile = (file: File): Promise<Record<string, any>[]> => new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
        try {
            const data = new Uint8Array(e.target?.result as ArrayBuffer);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json<Record<string, any>>(worksheet);

            if (jsonData.length === 0) {
                reject(new Error('EMPTY_FILE'));
                return;
            }

            resolve(jsonData);
        } catch {
            reject(new Error('INVALID_FILE'));
        }
    };

    reader.onerror = () => reject(new Error('READ_ERROR'));
    reader.readAsArrayBuffer(file);
});
